import React from 'react';

export const SkeletonCard = () => {
  return (
    <div className=" w-full flex flex-col justify-between gap-[12px] shadow-md rounded-[12px] mx-auto p-4 animate-pulse">
      <div className="flex items-center justify-between mb-4">
        <div className="w-1/3 h-6 bg-gray-200 rounded"></div>
        <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
      </div>
      <div className="mb-2 space-y-2">
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-5/6 h-4 bg-gray-200 rounded"></div>
        <div className="w-2/3 h-4 bg-gray-200 rounded"></div>
      </div>
      <div className="flex space-x-2">
        <div className="flex-1 h-8 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
};
export const SkeletonCardList = () => {
  return (
    <div className=" w-full flex flex-col justify-between gap-[12px] shadow-md rounded-[12px] mx-auto p-4 animate-pulse">
      <div className="flex items-center justify-between mb-4">
        <div className="w-1/3 h-6 bg-gray-200 rounded"></div>
        <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
      </div>
      <div className="mb-2 space-y-2">
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-5/6 h-4 bg-gray-200 rounded"></div>
        <div className="w-2/3 h-4 bg-gray-200 rounded"></div>
      </div>
      <div className="flex space-x-2">
        <div className="flex-1 h-8 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
};
